export default __webpack_public_path__ + "static/media/info-icon.36fe27e4.svg";